<template>
    <div class="faqs-wrapper">
        <div v-for="faq in faqs" :key="faq.id" class="wrapper">
            <div class="q-background">
                <div class="q-wrapper" @click="activeFaq == faq.id ? activeFaq = null : activeFaq = faq.id">
                    <div class="chevron">
                        <i class="fas fa-chevron-down" v-if="activeFaq != faq.id"/>
                        <i class="fas fa-chevron-up" v-else/>
                    </div>
                    <div class="q-style">
                        <strong> {{ faq.q }} </strong>
                    </div>
                </div>
                <div v-if="activeFaq == faq.id" class="a-wrapper">
                    <div v-if="faq.a.length > 2" class="a-style-4">
                        <ol class="no-margin">
                            <li v-for="el in faq.a" :key="el"> {{ el }} </li>
                        </ol>
                    </div>
                    <div v-else-if="faq.a.length > 1 && faq.a.length <= 2">
                        <div v-for="el in faq.a" :key="el.activity" class="a-style-2">
                            <strong style="margin-right: 5px"> {{ el.activity }} </strong>  {{ el.date }}
                        </div>
                    </div>
                    <div v-else>
                        <div v-for="el in faq.a" :key="el" class="a-style" > {{ el }} </div>
                    </div>
                </div>
            </div>

        </div>

        <!-- <div>
            Si tienes otra pregunta, puedes escribirla aquí
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            activeFaq: null,
            faqs: [
                {
                    id: 1,
                    q:  '¿Cuánto tiempo demoraré en ir del aeropuerto al hotel?',
                    a:  ['Entre 15 y 20 minutos']
                },
                {
                    id: 2,
                    q:  '¿Cuales son los horarios de Check In y Check out en el hotel?',
                    a:  [
                            {activity: 'Check in:', date: 'Viernes 15 Noviembre - 4:00pm'},
                            {activity: 'Check out:', date: 'Lunes 18 Noviembre - 11:00am '}
                        ]
                }, 
                {
                    id: 3,
                    q:  '¿Qué incluye el plan "Todo incluído" del hotel?',
                    a:  [
                            'Desayuno, comida, y cena por parte del hotel',
                            'Hospedaje por 3 noches (15, 16 y 17 de noviembre de 2019)',
                            'Botanas, uso gratuito de kayaks, bicicletas, y juegos de mesa',
                            'Para los adultos, barra libre de bebidas nacionales'
                        ]
                },
                {
                    id: 5,
                    q:  '¿Aún puedo asistir a la boda?',
                    a:  ['Comunícate con la novia para que te proporcione esta información 👰🏻']
                }
            ]
        }
    }
}
</script>

<style lang="scss" scoped>
@import "./variables.scss";

.a-style {
    padding: 10px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 250px) {
        margin: 10px 0;
    }
}

.a-style-2 {
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    @media screen and (max-width: 360px) {
        flex-direction: column;
        padding: 15px;
    }
}

.a-style-4 {
    display: flex;
    margin-left: 80px;
    text-align: left;
    @media screen and (max-width: $break-md) {
        margin-left: 40px;
    }
    @media screen and (max-width: $break-sm) {
        margin-left: 20px;
    }
}

.a-wrapper {
    width: 100%;
    cursor: text;
    margin-bottom: 5px;
    background: white;
}

.chevron {
    opacity: 0.2;
    margin: 10px;
}

.faqs-wrapper {
    text-align: -webkit-center;
}

.no-margin {
    margin: 0;
    padding: 10px;
}

.q-background {
    margin: 5px;
    display: flex;
    cursor: pointer;
    margin-bottom: 4px;
    flex-direction: column;
}

.q-style {
    flex: 1;
    padding: 5px;
    color: lightslategrey;
    @media screen and (max-width: $break-md) {
        font-size: 17px;
    }
    @media screen and (max-width: $break-sm) {
        font-size: 15px;
    }
}

.q-wrapper {
    display: flex;
    font-size: 20px;
    min-height: 40px;
    margin-left: 7px;
    align-items: center;
}

.wrapper {
    width:50%;
    background: lightcyan;
    @media screen and (max-width: $break-lg) {
        width:60%;
    }
    @media screen and (max-width: $break-md) {
        width:80%;
    }
    @media screen and (max-width: $break-sm) {
        width:90%;
    }

}

</style>


